<template>
  <div class="header">

    <van-popup v-model="showCode" @click-overlay="handleClose">
      <div class="popup-div">
        <div class="div-close" @click="handleClose">
          <img src="@/assets/images_member/Frame@3x.png" class="img-close" alt="" />
        </div>
        <div class="div-txt">联系企业客服</div>
        <img :src="service_qr_code" class="img" alt="" />
        <div class="div-tip">长按图片识别二维码添加企业客服</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {getWxPublicInfo} from '@/api/person'
export default {
  name: 'HeaderComponent',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    dialog (newval, oldval) {
      this.showCode = newval
    }
  },
  data () {
    return {
      showCode: false,
      service_qr_code: ''
    }
  },
  mounted () {
    this.handleFun()
  },
  methods: {
    handleClose() {
      this.showCode = false
      this.$parent.$data.dialog = false
    },
    handleFun() {
      getWxPublicInfo().then(res => {
        this.service_qr_code = res.data.service_qr_code
      })
    }
  },
}
</script>
<style lang="less" scoped>
.header {
  width: 100vw;
  padding-top: 56px;

  .van-popup {
    width: 300px;
    height: 261px;
    background-color: #2f3131;
    border-radius: 10px;

    .popup-div {
      display: flex;
      flex-direction: column;
      align-items: center;

      .img-close {
        width: 21px;
        height: 21px;
        position: absolute;
        top: 16px;
        right: 16px;
      }

      .div-txt {
        font-size: 18px;
        color: #fff;
        font-weight: bold;
        margin-top: 20px;
        line-height: 18px;
      }

      .img {
        width: 133px;
        height: 133px;
        border-radius: 10px;
        background-color: #fff;
        margin-top: 20px;
      }

      .div-tip {
        font-size: 14px;
        color: #fff;
        font-weight: 500;
        margin-top: 26px;
        line-height: 14px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/CustomerService.vue